import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import DummyProductImage from "../Components/DummyImage";
import { FaFileAlt, FaCheck, FaPhoneAlt } from "react-icons/fa";

const productsCatalog = [
  {
    id: "tin-ingots",
    title: "High-Purity Tin Ingots",
    category: "ingots",
    type: "tin",
    purity: "99.9% Pure Tin",
    packaging: "Standard 25kg Ingot Bundles",
    meltingPoint: "231.9°C",
    description: "JK Metal & Alloys manufactures premium high-purity Tin Ingots widely used in solder alloy production, electroplating, chemical compounds, food-grade packaging tinplate, and non-ferrous bronze foundries.",
    applications: ["Solder Manufacturing", "Electroplating", "Bronze & Brass Alloys", "Chemical Synthesis"]
  },
  {
    id: "lead-ingots",
    title: "Refined Pure Lead Ingots",
    category: "ingots",
    type: "lead",
    purity: "99.97% Refined Lead",
    packaging: "25kg - 50kg Ingot Bars",
    meltingPoint: "327.5°C",
    description: "Our pure Lead Ingots are processed from high-grade raw materials ensuring low antimony and bismuth content. Engineered for lead-acid battery grids, radiation shielding, chemical tank linings, and cable jacketing.",
    applications: ["Lead-Acid Batteries", "X-Ray & Radiation Shielding", "Chemical Industry", "Sheet & Pipe Manufacturing"]
  },
  {
    id: "solder-wire",
    title: "Industrial Solder Wire",
    category: "solder",
    type: "solder",
    purity: "Custom Sn/Pb & Lead-Free Ratios",
    packaging: "500g, 1kg & 3kg Spools",
    meltingPoint: "183°C - 217°C",
    description: "Formulated for high electrical conductivity, non-spattering flux core, and rapid wetting. Essential for electronics PCB soldering, electrical repairs, cable termination, and transformer coil joints.",
    applications: ["Electronics PCB Assembly", "Electrical Appliances", "Automotive Wiring Harnesses", "Transformer Connections"]
  },
  {
    id: "solder-stick-63-37",
    title: "Solder Stick (63/37 Eutectic)",
    category: "solder",
    type: "solder",
    purity: "63% Tin / 37% Lead",
    packaging: "Box of 1kg / 5kg Sticks",
    meltingPoint: "183°C (Eutectic)",
    description: "The 63/37 eutectic solder stick melts sharply at 183°C with zero plastic range, preventing cold joints. Ideal for wave soldering pots, stained glass, dip tinning, and radiator repair.",
    applications: ["Wave Soldering Pots", "Dip Tinning Tanks", "Radiator Repair", "Stained Glass Joining"]
  },
  {
    id: "star-solder-stick",
    title: "Star Solder Stick",
    category: "solder",
    type: "solder",
    purity: "High Grade Soldering Alloy",
    packaging: "1kg Bundles",
    meltingPoint: "185°C - 235°C",
    description: "Star Solder Sticks are crafted for manual soldering applications where smooth flow and high mechanical strength are required. Provides bright, shiny solder joints with excellent adhesion.",
    applications: ["Sheet Metal Joining", "Brassware Repair", "Plumbing Joints", "Electrical Terminals"]
  },
  {
    id: "small-solder-ingot",
    title: "Small Solder Ingot",
    category: "ingots",
    type: "tin",
    purity: "Custom Solder Formulations",
    packaging: "1kg Ingot Blocks",
    meltingPoint: "183°C - 250°C",
    description: "Compact solder ingots designed for easy handling and replenishment in small bath soldering pots, jewelry manufacturing, and precision alloy blending.",
    applications: ["Small Wave Baths", "Jewelry Soldering", "Custom Alloy Blends", "Dip Coating"]
  },
  {
    id: "long-solder-ingot",
    title: "Long Solder Ingot",
    category: "ingots",
    type: "tin",
    purity: "High Capacity Industrial Grade",
    packaging: "Extended Length Ingot Bars",
    meltingPoint: "183°C - 260°C",
    description: "Extended long solder ingots intended for heavy-duty industrial soldering machines and large solder pots, reducing furnace downtime during continuous runs.",
    applications: ["Automated Circuit Board Production", "Continuous Dip Coating", "Heavy Electrical Manufacturing"]
  },
  {
    id: "solder-paste",
    title: "Industrial Solder Paste",
    category: "solder",
    type: "solder",
    purity: "Type 3 & Type 4 Powder",
    packaging: "500g Jars / 100g Syringes",
    meltingPoint: "183°C / 217°C",
    description: "High precision solder paste for SMT surface mount technology. Ensures clean stencil printing, low voiding, and superior thermal resistance.",
    applications: ["SMT Electronics Manufacturing", "Micro-electronics", "LED Assembly"]
  },
  {
    id: "copper-axe",
    title: "Copper Axe & Forged Shapes",
    category: "copper",
    type: "copper",
    purity: "99.9% Electrolytic Copper",
    packaging: "Custom Weight Units",
    meltingPoint: "1085°C",
    description: "Forged copper axes manufactured from electrolytic high-conductivity copper. Used in heavy electrical earthing, heavy current switches, and specialized machining tooling.",
    applications: ["Electrical Grounding & Earthing", "Heavy Duty Switches", "Machined Components"]
  },
  {
    id: "copper-round-bar",
    title: "Copper Round Bar & Flats",
    category: "copper",
    type: "copper",
    purity: "ETP Grade Copper",
    packaging: "Standard Length Rods & Busbars",
    meltingPoint: "1085°C",
    description: "High electrical conductivity copper round bars, busbars, and flat strips. Ideal for electrical panels, power distribution transformers, switchgear, and motor windings.",
    applications: ["Transformer Busbars", "Control Panels", "Motor Windings", "Electrical Connectors"]
  }
];

const ProductsPg = () => {
  const [activeTab, setActiveTab] = useState("all");

  const filteredProducts = activeTab === "all" 
    ? productsCatalog 
    : productsCatalog.filter(p => p.category === activeTab);

  return (
    <div className="page-wrapper">
      {/* BANNER */}
      <section className="page-banner">
        <div className="page-banner-container">
          <h1>Product Catalog</h1>
          <p>Explore High Purity Tin, Lead, Solder Wires, Solder Sticks &amp; Copper Alloys</p>
        </div>
      </section>

      {/* FILTER TABS */}
      <section className="products-catalog-section">
        <div className="container">
          <div className="tab-buttons-row">
            <button 
              className={`tab-btn ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => setActiveTab('all')}
            >
              All Products ({productsCatalog.length})
            </button>
            <button 
              className={`tab-btn ${activeTab === 'ingots' ? 'active' : ''}`}
              onClick={() => setActiveTab('ingots')}
            >
              Metal Ingots (Tin &amp; Lead)
            </button>
            <button 
              className={`tab-btn ${activeTab === 'solder' ? 'active' : ''}`}
              onClick={() => setActiveTab('solder')}
            >
              Solder Products &amp; Wires
            </button>
            <button 
              className={`tab-btn ${activeTab === 'copper' ? 'active' : ''}`}
              onClick={() => setActiveTab('copper')}
            >
              Copper Products &amp; Bars
            </button>
          </div>

          {/* PRODUCTS LIST GRID */}
          <div className="products-detail-grid">
            {filteredProducts.map((product) => (
              <motion.div 
                className="product-detail-card" 
                key={product.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
              >
                <div className="product-card-img-wrap">
                  <DummyProductImage title={product.title} category={product.category} type={product.type} />
                </div>
                <div className="product-card-info">
                  <span className="badge-tag">{product.category.toUpperCase()}</span>
                  <h2>{product.title}</h2>
                  <p className="product-desc-text">{product.description}</p>
                  
                  <div className="product-specs-table">
                    <div className="spec-row">
                      <span>Purity Grade:</span>
                      <strong>{product.purity}</strong>
                    </div>
                    <div className="spec-row">
                      <span>Melting Point:</span>
                      <strong>{product.meltingPoint}</strong>
                    </div>
                    <div className="spec-row">
                      <span>Packaging:</span>
                      <strong>{product.packaging}</strong>
                    </div>
                  </div>

                  <div className="product-applications-tags">
                    <strong>Key Uses:</strong>
                    <div className="tags-flex">
                      {product.applications.map((app, idx) => (
                        <span key={idx} className="app-chip"><FaCheck className="chip-icon" /> {app}</span>
                      ))}
                    </div>
                  </div>

                  <div className="product-card-action">
                    <Link to="/product-enquiry" className="btn-gold-sm">
                      Request Quotation &rarr;
                    </Link>
                    <a href="tel:+918511698600" className="btn-outline-sm">
                      <FaPhoneAlt style={{ marginRight: '5px' }} /> Call Sales
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="page-cta-bar">
        <div className="container center">
          <h2>Need Custom Alloy Ratios or Bulk Wholesale Pricing?</h2>
          <p>We supply tailored chemical compositions, Sn/Pb ratios, and bulk shipments across India.</p>
          <Link to="/product-enquiry" className="btn-gold">Submit RFQ Online</Link>
        </div>
      </section>
    </div>
  );
};

export default ProductsPg;